import { ConferenceMemberRemovedByYouEvent, HistoryMessageItem, useIM } from '@wui/im'

import { useAutoAnswer } from '@/shared/composables/use-auto-answer'
import { useRoomControl } from '@/shared/composables/use-room-control'
import { fromPServedUser } from '@/shared/utils/uri'

export const call = (roomPServed: string, pServed: string) => {
  const { memberCall } = useRoomControl()
  const { registerAutoAnswer } = useAutoAnswer()

  registerAutoAnswer(roomPServed, true, true)
  const guestNumber = fromPServedUser(pServed)
  memberCall(roomPServed, guestNumber)
}

export const remove = (pServed :string, targetNumber: string): Promise<HistoryMessageItem<ConferenceMemberRemovedByYouEvent>> => {
  return useIM().removeSubscriber({
    pServed,
    targetInternalNumber: targetNumber,
  })
}
